import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { ReactiveFormsModule, type ValidationErrors } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  AddressInputComponent,
  MIN_PHONE_NUMBER_LENGTH,
} from '@principle-theorem/ng-principle-shared';
import {
  AlertComponent,
  NgDialogModule,
  TrackByFunctions,
} from '@principle-theorem/ng-shared';
import { type Lab } from '@principle-theorem/principle-core';
import { LabFormGroup } from './lab-form-group';

export interface ILabCreateData {
  title: string;
  submitLabel: string;
  lab?: Lab;
}

@Component({
  selector: 'pr-lab-create',
  templateUrl: './lab-create.component.html',
  styleUrls: ['./lab-create.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    AlertComponent,
    NgDialogModule,
    AddressInputComponent,
  ],
})
export class LabCreateComponent {
  trackByError = TrackByFunctions.field<ValidationErrors>('value');
  minPhoneLength = MIN_PHONE_NUMBER_LENGTH;
  labForm = new LabFormGroup();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ILabCreateData,
    private _dialogRef: MatDialogRef<LabCreateComponent>
  ) {
    this.labForm.patchValue(this.data.lab ?? {});
  }

  submit(): void {
    if (this.labForm.invalid) {
      return;
    }
    const data = this.labForm.getRawValue();

    this._dialogRef.close({
      ...data,
      address: data.address.address,
      metadata: { address: data.address },
    });
  }
}
